import { Injectable } from '@angular/core';
import { CustomStorage } from './Custom-storage.service';
import { EventEmitter } from '@angular/core';
import { Output } from '@angular/core';
import { RestApiServices } from './rest.service';
import { Constant } from '../Constant';

@Injectable()
export class CartitemsService {

  @Output() cartList: EventEmitter<any> = new EventEmitter();
  @Output() orderNumber: EventEmitter<any> = new EventEmitter();
  private cartItems = [];
  repeatOrderData: any;
  invoicestatuses: any = {};
  orderstatuses: any = {};
  constructor(private restService: RestApiServices) {
    //  this.loadCartItems();
  }
  setOrderNo(order) {
    this.orderNumber = order;
  }

  getOrderNo() {
    return this.orderNumber;
  }

  loadCartItems() {
    this.restService.getcartproducts().subscribe(data => {
      if (data) {
        this.cartItems = data;
        this.cartList.emit(this.cartItems);
      }
    }, error =>{
    });
  }

  fireCartList() {
    this.cartList.emit(this.cartItems);
  }

 addItemtoCart(product) {
  let id = product['item_number'];
    let color = product.item_color;
    let size = product.item_size;
    let quantityVal = product.quantity;
    let quantityAddedFlag = false;
    //this.cartItems.push(product);
    let cartItemQuantity;
    this.restService.addCartItem(product).subscribe(data => {
      if (data) {
        for (let item of data) {
          for (let cart of this.cartItems) {
            //if (item.temp_id === cart.item_number && color === item.item_color && size === item.item_size) {
            //if (item.unique_id === cart.temp_id && id === item.item_number && color === item.item_color && size === item.item_size) {
            // cart.unique_id = item.unique_id;
            if (item.unique_id ===  cart.unique_id) {   
             item['quantity'] += quantityVal;
             cartItemQuantity = item['quantity'];
              // cart['quantity'] += quantityVal;
              // cartItemQuantity = cart['quantity'];
              quantityAddedFlag = true;
              break;
            }
          }
          if (!quantityAddedFlag) {
            //product['quantity'] = quantityVal;
            this.cartItems.push(product);
          }
        }

        this.cartList.emit(this.cartItems);
      }
      else{
           // product['quantity'] = quantityVal;
            this.cartItems.push(product);
          }
    });
  }

  getCartItems() {
    return this.cartItems;
  }
  getCartItemsCount() {
    return this.cartItems.length;
  }

  removeCartItem(product) {
    let index = 0;
    for (let item of this.cartItems) {
      if (product.unique_id === item.unique_id) {
        this.cartItems.splice(index, 1);
        break;
      }
      index++;
    }

    this.restService.removeCartItems(product).subscribe(data => {
      if (data) {
        for (let item of data) {
          for (let cart of this.cartItems) {
            if (item.unique_id === cart.temp_id) {
              cart.unique_id = item.unique_id;
            }
          }
        }

        this.cartList.emit(this.cartItems);
      }
    });
  }
  removeAllCartItems() {

    this.cartItems = [];
    this.restService.emptyCartItems().subscribe(data => {
      if (data) {
        this.cartItems = [];
        this.cartList.emit(this.cartItems);
      }
    });
  }

  setRepeatedOrder(orderData) {
    this.repeatOrderData = orderData;
  }

}



// WEBPACK FOOTER //
// ./src/app/providers/cartitems.service.ts